import { PrismicDocument, Query, Slice } from '@prismicio/types'

export function generatePrismicDoc<T>(
  data: T,
  documentProperties?: Partial<PrismicDocument>,
) {
  // @ts-ignore
  const doc: PrismicDocument<T> = {
    type: '',
    ...(documentProperties || {}),
    data,
  }
  return doc
}
export function generateSlice<T>(data: T, sliceProperties?: Partial<Slice>) {
  // @ts-ignore
  const res: Slice<any, T> = {
    ...(sliceProperties || {}),
    primary: data,
  }
  return res
}
export function generateQuery<T extends PrismicDocument>(data: T[]) {
  const res: Query<T> = {
    next_page: '',
    page: 1,
    prev_page: '',
    results: data,
    results_per_page: data.length,
    results_size: data.length,
    total_pages: 1,
    total_results_size: data.length,
  }
  return res
}

export const slimSlices = (slices: Slice<'any'>[]) => {
  return slices?.map((slice) => ({
    id: slice.id,
    primary: slice.primary,
    slice_type: slice.slice_type,
  }))
}
export const slimDocument = (doc: PrismicDocument<any>) => {
  const res = {
    data: {
      ...doc.data,
    },
    id: doc.id,
    type: doc.type,
    uid: doc.uid,
  }
  if (doc.data.slices) {
    res.data.slices = slimSlices(doc.data.slices)
  }
  return res as any
}
